import type {EntityDraftApproveOption, EntityDraftMessageAction} from '@Components/ai-chat-window/components/entity-draft-group/entity-draft-group.types';
import type {ShownMoment} from '@Utils/friendly-moment.util';

/** Between an approve button's label and the moment it shows ("Schedule · Tomorrow, 5 PM"). */
export const DRAFT_BUTTON_MOMENT_SEPARATOR = ' · ';

export interface DraftApproveButtonProps {
  label: string;
  approveOptions?: EntityDraftApproveOption[];
  messageAction?: EntityDraftMessageAction;
}

export interface DraftApproval {
  /** Only the latest draft still waiting carries the button; it approves every draft waiting beside it, except one approved alone, which carries its own. */
  hasApproveButton: boolean;
  approvedTogetherCount: number;
  /** The drafts it approves do different things (publish, schedule, save), so the button names no single one. */
  approvesDifferentActions: boolean;
}

export enum DraftButtonKind {
  APPROVE = 'approve',
  MESSAGE = 'message',
}

/**
 * A button that approves the draft, with the option it carries when the card offers several ways to approve. Pressing
 * it says its label; the moment, when it has one, is only shown beside the label.
 */
export interface DraftApproveChoice {
  kind: DraftButtonKind.APPROVE;
  label: string;
  optionId: string | null;
  moment?: ShownMoment;
}

/** A button that asks in the chat, as the user's own message, and leaves the draft waiting. */
export interface DraftMessageChoice {
  kind: DraftButtonKind.MESSAGE;
  label: string;
  message: string;
}

export type DraftSecondaryChoice = DraftApproveChoice | DraftMessageChoice;

export interface DraftApprovalButtons {
  primary: DraftApproveChoice;
  secondary: DraftSecondaryChoice | null;
}
